module.exports = {"title":"비정상 홀 리스트","headerGolfClub":"골프장","headerPinId":"핀ID","headerReport":"보고","headerBattery":"배터리","headerAlarm":"알림","statusNormal":"정상","chargeRequired":"충전 필요","smsHeader":"[APL 알림]","smsErrorOccurred":"보이스캐디 APL서비스 오류 발생.","smsHoleItem":"{course}코스 {hole}홀 No.{id}","smsFooter":"점검 부탁 드립니다.","sendSms":"문자 보내기","call":"전화 걸기","noContact":"담당자 연락처가 없습니다.","smsSent":"SMS가 전송되었습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/ma101.json
// module id = gRZx
// module chunks = 2